import SmartImage from "./SmartImage";

export default function PageBanner({ title, eyebrow, image, height = "h-[180px] md:h-[230px]" }) {
    return (
        <section
            className={`relative w-full ${height} overflow-hidden mt-16 lg:mt-[8.5rem]`}
            data-testid="page-banner"
        >
            {image && (
                <SmartImage
                    src={image}
                    alt={title}
                    className="absolute inset-0 w-full h-full object-cover"
                />
            )}
            {/* Pink-tinted overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-blush/20 via-black/35 to-black/55" />
            <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center text-white">
                {eyebrow && (
                    <p className="text-[10px] md:text-xs tracking-[0.45em] uppercase text-blush-pale mb-3 font-medium">
                        {eyebrow}
                    </p>
                )}
                <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-none" data-testid="banner-title">
                    {title}
                </h1>
                <div className="mt-4 h-[2px] w-14 bg-blush" />
            </div>
        </section>
    );
}
